import * as React from 'react';
import { ArticleHeading1, ArticleParagraph2, InlineText1 } from '@cian/ui-kit';
import { ArrowOut16 } from '@cian/ui-kit/prev';
import { IWebsite } from '../../types/developer/contacts';
import * as styles from './Contacts.css';

interface IContactsProps {
  address: string;
  workTime: string | null;
  website: IWebsite | null;
  phoneNumber: string;
  call: React.ReactNode;
  callback: React.ReactNode;
}

export function Contacts({ address, workTime, website, callback, call }: IContactsProps) {
  return (
    <div className={styles['contacts']}>
      <div className={styles['contacts__title']}>
        <ArticleHeading1>Контакты</ArticleHeading1>
      </div>

      <div className={styles['contacts__item']}>
        <div className={styles['contacts__item-label']}>
          <ArticleParagraph2 color="gray60_100">Центральный офис</ArticleParagraph2>
        </div>
        <InlineText1>{address}</InlineText1>
      </div>

      <div className={styles['contacts__item']}>
        <div className={styles['contacts__item-label']}>
          <ArticleParagraph2 color="gray60_100">Режим работы</ArticleParagraph2>
        </div>
        <InlineText1>{workTime}</InlineText1>
      </div>

      {website && (
        <div className={styles['contacts__item']}>
          <div className={styles['contacts__item-label']}>
            <ArticleParagraph2 color="gray60_100">Сайт застройщика</ArticleParagraph2>
          </div>
          <span className={styles['contacts__website']}>
            <a href={website.url} target="_blank" rel="noopener noreferrer">
              <InlineText1 color="primary_100">{website.label}</InlineText1>
            </a>
            <ArrowOut16 color="primary_100" />
          </span>
        </div>
      )}

      <div className={styles['contacts__newbuilding-button']}>{call}</div>

      {callback}
    </div>
  );
}
